import { IIsiDtoPlMarkClauseWhere, IIsiDtoSelectedRecordSet, IsiDtoPlMarkGetMarkUnmarkResult, IsiDtoPlMarkRecords, IsiDtoPlMarkRequest, IsiDtoPlMarkResponse } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlMark";
import { IIsiUIFlowResult } from "../Core/IIsiUIFlowResult";
import { IsiIWSAssociatedViewContext } from "../GridView/AssociatedView/IsiIwsAssociatedViewContext";
import { IsiPresentationLogic } from "./IsiPresentationLogic";

export interface MarkUnmarkOpt {
    itemClick: string;
    recordSet: IIsiDtoSelectedRecordSet;
    itemGroup: string;
    inGrid: boolean;
};

type ParamPlMark = {
    executeTraitement: boolean,
    table: string,
    clauseWhere: IIsiDtoPlMarkClauseWhere[],
    itemClick: string,
    recordSet: IIsiDtoSelectedRecordSet,
    itemGroup: string,
    inGrid: boolean,
    isMarking: boolean,
    contextId: string
};

export class IsiPlMark extends IsiPresentationLogic {

    constructor() {
        super("IsiPlMarkHandler");
    }

    /*-- CREATION -----------------------------------------------------------------------------
    '- Auteur      : RGEL
    '- Date        : 18/05/2011
    '- Description : DEV 41407 - Gestion du Marquage et du demarquage d enregistrements
    '- Modification: LFEN - DYFS0000089037 + Migration ts 
    '-----------------------------------------------------------------------------------------*/
    MarkUnmarkRecord(dto: MarkUnmarkOpt, gridContext: IsiIWSAssociatedViewContext): Promise<IIsiUIFlowResult> {

        return new Promise((resolve) => {

            if (!this._checkMarkUnmarkNeeded(dto)) {
                return new Promise((resolve) => {
                    resolve({ result: true, continue: true });
                });
            }

            let bExecuteTraitement = true;
            let ihdTPARAM: string;
            let clauseWhere: IIsiDtoPlMarkClauseWhere[] = [];
            let table = '';

            // On verifie qu'on n'est pas dans un ecran specifique
            // JSOU - 07/12/2018 - DYSF85835 - Il ne faut pas utiliser le document.title pour recuperer le formulaire
            switch (uiCore.getCurrentScreenCode()) {
                //l'ecran des options est specifique car cette cette ecran ne se reposte pas et 
                //quand on selectionne un element de l'arborescence, et qu'un repostage est effectuer dessus                                                                        
                //on revien sur l'element sur lequel on etait a l'arrive sur l'ecran                                                                        
                //On fait donc le traitement en ajax sans repostage sur cette ecran, 
                //on doit donc retrouver ca clause where et lui passer en parametre                                                                        
                //Enfin, on laisse les deux actions marquer/demarquer sur cette ecran                                                                       
                case "PARC023":

                    ihdTPARAM = iwsAllCtrls.tryGetFieldValue("ihdT_PARAM");
                    let itxtCPARAM = iwsAllCtrls.tryGetFieldValue("itxtC_PARAM");
                    let ihdCFAMPARAM = iwsAllCtrls.tryGetFieldValue("ihdC_FAMPARAM");

                    if (ihdTPARAM === "G") 
                    {
                        //On verifie si le code du parametre est renseigne
                        if (itxtCPARAM !== "") 
                        {
                            clauseWhere.push
                            (
                                { table: 'Z_PARAM', colonne: 'C_PARAM', value: iwsAllCtrls.tryGetFieldValue("itxtC_PARAM") },
                                { table: 'Z_PARAM', colonne: 'C_FAMPARAM', value: iwsAllCtrls.tryGetFieldValue("ihdC_FAMPARAM") }
                            ); 
                        }
                        else 
                        {
                            //Sinon, on verifie si on est sur la famille et quelle est renseigne
                            if (ihdCFAMPARAM !== "") 
                            {
                                clauseWhere.push
                                (
                                    { table: 'Z_PARAM', colonne: 'C_FAMPARAM', value: iwsAllCtrls.tryGetFieldValue("ihdC_FAMPARAM") }
                                ); 
                            }
                            else
                            {
                                //On est sur un noeud que l'on ne gere pas
                                //Affichage du message disant qu'on ne gere pas les profil, utilisateur, et nature
                                uiCore.showErrorMessage(getMessagesForJavascript().GetMessage("BadLevelAction").L_MESSAGE);
                                bExecuteTraitement = false;
                            }
                        }
                    }
                    else 
                    {
                        //Affichage du message disant qu'on ne gere pas les profil, utilisateur, et nature
                        uiCore.showErrorMessage(getMessagesForJavascript().GetMessage("BadParamMarkUnmark").L_MESSAGE);
                        bExecuteTraitement = false;
                    }
                    break;
                // le cas de l'ecran des menus est specifique aussi en effet la table associee a cette ecran est Z_MENU_MODULE hors nous on souhaite marquer la table Z_MENU                                                                        
                // cette specificite fait que la clause where disponible sur l'ecran est du genre C_MENU = AND C_MODULE =. 
                // On refait donc ici la clause were avec juste le C_MENU                                                                        
                //et on lui passe en parametre                                                                       
                case "ADM016":
                    clauseWhere.push
                    (
                        { table: 'Z_MENU', colonne: 'C_MENU', value: iwsAllCtrls.tryGetFieldValue("itxtC_MENU") },
                        { table: 'Z_MENU', colonne: 'C_BUREAU', value: iwsAllCtrls.tryGetFieldValue("itxtC_BUREAU") }
                    );
                    table = "Z_MENU";
                    break;
                default: //Sinon on est sur un cas par defaut avec traitement normal

                    break;
            }

            const theParams: ParamPlMark = {
                executeTraitement: bExecuteTraitement,
                table: table,
                clauseWhere: clauseWhere,
                itemClick: dto.itemClick,
                recordSet: dto.recordSet,
                itemGroup: dto.itemGroup,
                inGrid: dto.inGrid,
                contextId: null,
                isMarking: dto.itemClick == 'FORM_MARK_ITEM' || dto.itemClick == 'DATA_MARK_ITEM'
            }
            if (dto.inGrid) {
                theParams.contextId = gridContext.id;
            }
            return new Promise((resolve) => {
                this._markUnmark(theParams).then((getMarkUnmarkResult) => {

                    if (getMarkUnmarkResult.message) {
                        uiCore.showFeedback(getMarkUnmarkResult.message, getMarkUnmarkResult.hasError);
                    }
                    if (!getMarkUnmarkResult.hasError) {
                        this._updatePresentation(gridContext, dto);
                    }
                    resolve({ result: true, continue: false });
                }
                );
            });

        });
    }

    /**
     * Marquage du paramétrage
     * @param bCheckAll
     * @param assContextId
     */
    private _markUnmark(param: ParamPlMark): Promise<IsiDtoPlMarkGetMarkUnmarkResult> {
        return new Promise<IsiDtoPlMarkGetMarkUnmarkResult>((resolve, reject) => {


            let plMarkRecord = IsiDtoPlMarkRecords.fromJS({
                selected: param.recordSet
            });

            let request = IsiDtoPlMarkRequest.fromJS({
                mark: param.isMarking,
                records: plMarkRecord,
                itemClick: param.itemClick,
                contextId: param.contextId,
                isgrid: param.inGrid,
                clauseWhere: param.clauseWhere,
                table: param.table,
                response: IsiDtoPlMarkResponse.fromJS({
                })
            });
            this.ajax("GetMarkUnmark", request, true).then(
                (request: IsiDtoPlMarkRequest) => {
                    resolve(request.response.getMarkUnmarkResult);
                }
            ).catch((request: IsiDtoPlMarkRequest) => {
                reject(null);
            });
        });

    }

    /**
     * Modification de l'affichage suite aux traitements effectués
     */
    private _updatePresentation(gridContext: IsiIWSAssociatedViewContext, dto: MarkUnmarkOpt) {
        if (dto.inGrid) {

            // on veut décocher les checkbox     
            gridContext.clearSelectedRows();
            gridContext.refresh();
        } else {
            // on veut changer l'icône du marquage
            const icone = document.querySelector('#FormHeader_param.paramMode');
            const menuFormId = MNU_MASTER + MNU_SEP + FORM_MNUGRP_MISC + MNU_SEP;
            if (icone) {
                if (dto.itemClick == MARK_ITEM) {
                    icone.classList.add('mark_direct');
                    icone.classList.remove('unmark_direct');
                    uiCore.menuManager.hide(menuFormId + MARK_ITEM, false);
                    uiCore.menuManager.show(menuFormId + UNMARK_ITEM, false);
                } else if (dto.itemClick == UNMARK_ITEM) {
                    icone.classList.remove('mark_direct');
                    icone.classList.add('unmark_direct');
                    uiCore.menuManager.show(menuFormId + MARK_ITEM, false);
                    uiCore.menuManager.hide(menuFormId + UNMARK_ITEM, false);
                }
            }
        }
    }

    private _checkMarkUnmarkNeeded(dto: MarkUnmarkOpt): boolean {
        if (!dto.inGrid) {
            const icone = document.querySelector('#FormHeader_param.paramMode');
            if (icone) {
                if (dto.itemClick == MARK_ITEM && icone.classList.contains('mark_direct')) {
                    return false;
                } else if (dto.itemClick == UNMARK_ITEM && icone.classList.contains('unmark_direct')) {
                    return false;
                }
            }
        }
        return true;
    }

}

